import { ProductGroupName } from '@prlw/core/monitor/types/all-table';

export type AllInstruments = {
  shipmentBasis: string;
  shipmentBasisData: {
    code: string;
    stations: Station[];
    shipmentBasisName: string;
    shipmentBasisBriefDescription: string | null;
    manufacturers: string[];
  };
  instrumentsByProductGroup: {
    [key in ProductGroupName]?: Instrument;
  };
};

export type Instrument = {
  time: string;
  price: number;
  amount: number;
  amountDelta: number;
  priceDelta: number;
  tariffStatus:
    | TariffStatus.NotSent
    | TariffStatus.Tariff
    | TariffStatus.Wait
    | TariffStatus.TariffError;
  forecast: {
    basis: string;
    date: string;
    productGroup: string;
    trend: string;
    value: string;
  } | null;
  dealStatus: string;
  bestBuyPrice: number;
  bestSellPrice: number;
  instrumentCode: string;
  productName: string;
  shipmentTime: number;
  deliveryTime: number;
};

export type Station = {
  id: number;
  name: string;
  code: string;
  stationId: string;
  latitude: string;
  longitude: string;
  createdAt: string;
  updatedAt: string;
  order: string | null;
  isPricingPoint: boolean;
  basisId: number;
};

export enum TariffStatus {
  NotSent = 'NotSent',
  Wait = 'Wait',
  Tariff = 'Tariff',
  TariffError = 'TariffError',
}
